import React from 'react';
import { Avatar, Typography, Paper } from '@mui/material';
import { useUserContext } from '../context';
import ProfileLinks from './ProfileLinks';
import ProfileBio from './ProfileBio';
import './index.scss';

function UserProfileHeader() {
  const { userData } = useUserContext();

  return (
    <Paper elevation={0} className="profile-header">
      <div>
        <Avatar
          alt={userData.name}
          src={`https://github.com/${userData.githubUsername}.png`}
          className="profile-avatar"
          sx={{ width: 130, height: 130 }}
        />
        <ProfileLinks />
      </div>

      <div className="profile-info">
        <Typography variant="h4" component="h1">{userData.name}</Typography>
        <Typography 
          variant="h6" 
          color="textSecondary" 
          gutterBottom
        >
          {userData.username}
        </Typography>
        <ProfileBio />
      </div>
    </Paper>
  );
}

export default UserProfileHeader;
